<template>
    <div>
        <base-header type="gradient-primary" class="pb-3 pt-5 pt-md-8">

        </base-header>

        <div class="container-fluid mt--7">
            <div class="row mt-5 mb-3">
                <div class="col-12 mb-5 mb-xl-0">


                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col col-md-auto">
                                    <base-input class="input-group-alternative"
                                                placeholder="Search"
                                                addon-left-icon="fas fa-search"
                                                v-model="filters.name.value">
                                    </base-input>
                                </div>

                                <div class="col-auto col-md text-right">
                                    <base-button type="primary" @click="addBg()">
                                        <i class="fas fa-plus-circle fa-lg"></i>
                                        Add
                                    </base-button>
                                </div>
                            </div>
                        </div>


                        <div class="table-responsive">
                            <v-table class="table"
                                     :data="list"
                                     :currentPage.sync="currentPage"
                                     :pageSize="pageSize"
                                     @totalPagesChanged="totalPages = $event"
                                     :filters="filters"
                            >

                                <thead slot="head">
                                <v-th sortKey="name">Image</v-th>
                                <v-th sortKey="value">Name</v-th>
                                <th></th>
                                </thead>
                                <tbody slot="body" slot-scope="{displayData}">
                                <tr v-for="row in displayData" :key="row.id">
                                    <td>
                                        <img class="img-fluid bg" :src="`${apiUrl}/uploads/${row.value}`">
                                    </td>

                                    <td>
                                        {{row.name}}
                                    </td>

                                    <td class="text-right">
                                        <base-button type="secondary" @click="deleteBg(row)">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </base-button>
                                    </td>
                                </tr>
                                </tbody>
                            </v-table>
                        </div>

                        <div class="row justify-content-end">
                            <div class="col-auto">
                                <smart-pagination
                                        :currentPage.sync="currentPage"
                                        :totalPages="totalPages"
                                        :maxPageLinks="3"
                                />
                            </div>
                        </div>


                    </div>


                </div>
            </div>
        </div>

    </div>
</template>
<script>

    import {
        DELETE_BACKGROUND,
        GET_BACKGROUND,
    } from "../store/actions.type";
    import store from '../store';
    import {mapState} from 'vuex';
    import {API_URL} from '../config/constant'
    import Swal from 'sweetalert2'

    export default {
        computed: {
            ...mapState({
                list: state => state.background.list,
            }),
        },
        async created() {
            this.setting = await store.dispatch(
                GET_BACKGROUND
            );
        },

        data() {
            return {
                currentPage: 1,
                totalPages: 0,
                pageSize: 10,
                apiUrl: API_URL,
                filters: {
                    name: {value: '', keys: ['name']}
                },
            };
        },
        methods: {
            addBg() {
                const panelInstance = this.$showPanel({
                    component: 'addbg',
                    width: '500px',
                });

                panelInstance.promise
                    .then(result => {
                        if (result.confirm) {
                            store.dispatch(GET_BACKGROUND);
                        }
                    });
            },

            deleteBg(data) {

                Swal.fire({
                    type: 'warning',
                    text: `ต้องการลบรูปพื้นหลัง ${data.name} ?`,
                    showCancelButton: true,
                    focusConfirm: false,
                    focusCancel: false,
                    reverseButtons: true,
                    customClass: {
                        confirmButton: 'btn-primary',
                        cancelButton: 'btn-danger',
                    }

                }).then(async (result) => {
                    if (result.value) {
                        await store.dispatch(DELETE_BACKGROUND, data.id);

                        Swal.fire(
                            {
                                text: `ทำรายการสำเร็จ`,
                                type: 'success',
                                customClass: {
                                    confirmButton: 'btn-primary'
                                }
                            }
                        );

                        await store.dispatch(GET_BACKGROUND);
                    }
                })


            }
        }

    };
</script>
<style scoped lang="scss">
    .table td {
        white-space: normal;
        vertical-align: middle;
    }

    .bg {
        max-height: 150px;
    }
</style>
